import PropTypes from 'prop-types';
import { useAnalytics } from 'use-analytics';
import { useSelector } from 'react-redux';
import { BookingAction } from '../../../../../constants';
import ConfirmModal from '../../../../ConfirmModal';

const LowerCabinAlertModal = ({ setDoShowMixedCabinWarning, onConfirmClick }) => {
  const { track } = useAnalytics();
  const { email: loggedInUserEmail } = useSelector((store) => store.user);

  return (
    <ConfirmModal
      okButtonLabel="Book"
      cancelButtonLabel="Cancel"
      event="Lower cabin alert modal"
      onConfirm={() => {
        onConfirmClick(BookingAction.BOOK);
        setDoShowMixedCabinWarning(false);
        track('LowerCabinAlertModal.Confirmed', {
          loggedInUserEmail,
          page: window.location.search,
        });
      }}
      onCancel={() => {
        setDoShowMixedCabinWarning(false);
        track('LowerCabinAlertModal.Canceled', { loggedInUserEmail, page: window.location.search });
      }}
      message={
        <div className="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4">
          <span>
            <b>Warning:</b> One or more flights in your selected itinerary include a cabin class
            lower than your requested preference.
            <br />
            To ensure all flights meet your desired cabin class, please adjust your preferences or
            <br />
            <b>Use the &quot;Avoid cabin downgrade&quot; preference.</b>
            <br />
            <br />
            Click &quot;Cancel&quot; to modify your preferences or &quot;Book&quot; to continue
            booking with the current selection.
          </span>
        </div>
      }
    />
  );
};

LowerCabinAlertModal.propTypes = {
  onConfirmClick: PropTypes.func.isRequired,
  setDoShowMixedCabinWarning: PropTypes.func.isRequired,
};

export default LowerCabinAlertModal;
